import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type {
    PaymentProvider} from "@@/shared/payments/payment-providers";
import {
    paymentProviderZodSchema,
} from "@@/shared/payments/payment-providers";
import type { Except } from "type-fest";
import { z } from "zod";
import type {
    FeeSourceOrdersFilterId} from "./fee-source-orders-filter-id";
import {
    feeSourceOrdersFilterIdFactory,
    feeSourceOrdersFilterIdZodSchema,
} from "./fee-source-orders-filter-id";

type FeeSourceOrdersFilterPaymentProvider = {
    readonly _id: FeeSourceOrdersFilterId;
    readonly _type: "FEE_SOURCE_ORDERS_FILTER";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly type: "PAYMENT_PROVIDER";
    readonly paymentProvider: PaymentProvider;
    readonly invert?: boolean;
};

type Params = Except<
    FeeSourceOrdersFilterPaymentProvider,
    "_id" | "type" | "_type" | "_createdAt"
>;
const feeSourceOrdersFilterPaymentProviderFactory = (
    params: Params,
): FeeSourceOrdersFilterPaymentProvider => {
    return {
        ...params,
        _id: feeSourceOrdersFilterIdFactory(),
        _type: "FEE_SOURCE_ORDERS_FILTER",
        _createdAt: nowIsoAndUnix(),
        type: "PAYMENT_PROVIDER",
    };
};

const feeSourceOrdersFilterPaymentProviderZodSchema: z.ZodSchema<FeeSourceOrdersFilterPaymentProvider> =
    z.object({
        _id: feeSourceOrdersFilterIdZodSchema,
        _type: z.literal("FEE_SOURCE_ORDERS_FILTER"),
        _createdAt: isoAndUnixZodSchema,
        type: z.literal("PAYMENT_PROVIDER"),
        paymentProvider: paymentProviderZodSchema,
        invert: z.boolean().optional(),
    });

export {
    feeSourceOrdersFilterPaymentProviderFactory,
    feeSourceOrdersFilterPaymentProviderZodSchema,
};
export type { FeeSourceOrdersFilterPaymentProvider };
